import Image from "next/image";
import Link from "next/link";

export default function HowToDeposit() {
  const dmAppUrl = !(typeof window === "undefined")
    ? /(localhost)|(staging)/.test(window.location.hostname)
      ? "https://staging.datamynt.com"
      : "https://datamynt.com"
    : "#";

  return (
    <div>
      Currently, Data Mynt deposits are handled through Moonpay, a trusted
      partner leader in digital assets payments worldwide. (We’ll also be adding
      Banxa in a few weeks)
      <br />
      <br />
      Here’s a step by step guide on how to deposit funds into your Data Mynt
      Global Business Wallet with Moonpay:
      <ul>
        <li>
          Log in at{" "}
          <Link href={dmAppUrl}>
            <a target="_blank" rel="noreferrer">
              Data Mynt App
            </a>
          </Link>
          , add the amount you want to deposit into the deposit box, and click
          continue
        </li>
        <div className="flex items-center justify-center question-image-container">
          <Image
            alt="First step of deposit"
            width={300}
            height={170}
            src="/depositFirstStep.png"
          />
        </div>
        <li>
          You’ll be asked for a verification code sent to your mail address.
          Enter the code and click continue.
        </li>
        <li>
          For the next step, you’ll need to fill a form with your basic
          information. Fill the form and click continue
        </li>
        <div className="flex items-center justify-center question-image-container">
          <Image
            width={300}
            height={400}
            alt="Second step of deposit"
            src="/depositSecondStep.png"
          />
        </div>
        <li>
          Next, you’ll be asked to enter your billing address in order to
          process the deposit.
        </li>
        <div className="flex items-center justify-center question-image-container">
          <Image
            width={300}
            height={400}
            alt="Third step of deposit"
            src="/depositThirdStep.png"
          />
        </div>
        <li>
          Depending on your country’s regulation you could be asked to verify
          your phone number in order to continue with the process.
        </li>
        <div className="flex items-center justify-center question-image-container">
          <Image
            width={300}
            height={400}
            alt="Fourth step of deposit"
            src="/depositFourthStep.png"
          />
        </div>
        <li>
          Next, you’ll need to verify your identity. This process consists of
          only 4 to 5 steps and is optimized to approve your verification almost
          instantly after the requirements are sent.
        </li>
        <li>
          The first step consists of selecting the type of document you’ll
          upload in order to verify your identity and the country of issuance.
        </li>
        <div className="flex items-center justify-center question-image-container">
          <Image
            width={300}
            height={400}
            alt="Fifth step of deposit"
            src="/depositFifthStep.png"
          />
        </div>
        <li>
          The final process of identity verification needs to be completed on
          your phone. In order to do this you have two options: scan the QR
          provided or receive a link via text message. Select your preferred
          method and continue on your phone.
        </li>
        <div className="flex items-center justify-center question-image-container">
          <Image
            width={300}
            height={400}
            alt="Sixth step of deposit"
            src="/depositSixthStep.png"
          />
        </div>
        <li>
          Upload the required photos of the document you’ve selected and take a
          selfie to complete the verification process. If these steps are done
          right, you will receive the approval almost immediately.
        </li>
        <div className="flex items-center justify-center question-image-container">
          <Image
            width={300}
            height={400}
            alt="Seventh step of deposit"
            src="/depositSeventhStep.png"
          />
        </div>
        <li>
          Last but not least, add your payment method and confirm your deposit.
        </li>
        <div className="flex items-center justify-center question-image-container">
          <Image
            width={300}
            height={200}
            alt="Eigth step of deposit"
            src="/depositEigthStep.png"
          />
        </div>
      </ul>
    </div>
  );
}
